import FaqSectionImplementation from '../implementation/sections/FaqSection';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import {
  StrapiFaqSectionDTO,
  FaqSectionDTO,
} from '@lib/strapi/dtos/components/sections/faqSection.dto';

const FaqSection = (props: ComponentProps<FaqSectionDTO>) => {
  return <FaqSectionImplementation {...props}></FaqSectionImplementation>;
};

export default FaqSection;
